import { UserMarkup_saveToVault } from './UserMarkupPopup.locstring.json';
import showVaultPopup from './VaultPopup';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { IPoint } from '@fluentui/react/lib/Utilities';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import React from 'react';

const styles = require('./UserMarkupPopup.scss');

export interface VaultOptionProps {
    target: IPoint | HTMLElement;
    selectedText: string;
    destroyPopupDivCallback: () => void;
}

// The option to store the user selected info in the Vault for future usage.
const VaultOption = observer(function VaultOption(props: VaultOptionProps) {
    const { target, selectedText, destroyPopupDivCallback } = props;

    const onShowPopup = React.useCallback(() => {
        destroyPopupDivCallback();
        showVaultPopup(target, selectedText);
    }, [target, selectedText, destroyPopupDivCallback]);

    return (
        <TooltipHost content={loc(UserMarkup_saveToVault)}>
            <IconButton
                className={styles.UserMarkupPopupButton}
                iconProps={{ iconName: ControlIcons.Save }}
                onClick={onShowPopup}
            />
        </TooltipHost>
    );
});

export default VaultOption;
